import { treatmentTypes } from "./utils";

export const Medication = ({ medication, summary = false }) => {
  return (
    <div>
      <div
        className={`py-3 px-8 rounded-2xl min-h-[35px] ${
          medication?.type === treatmentTypes.PharmacologicalIntranasalTherapy
            ? "bg-green-100"
            : "bg-teal-75"
        }`}
      >
        <div className="text-base font-bold text-teal-300">
          {medication?.label || "undefined"}
        </div>
        {medication.dosage && (
          <div className="text-sm text-teal-300">{medication?.dosage}</div>
        )}
        {/* {medication.instruction && (
          <div className="text-sm text-teal-300">{medication?.instruction}</div>
        )}
        {medication.sig && (
          <div className="text-sm text-teal-300">{medication?.sig}</div>
        )} */}
      </div>
      {/* Print layout for the frame/cards: see @media print rules in src/index.scss (.storyboard-medication-*) */}
      <div className="my-8 print:my-4 page-section">
        <div className="relative storyboard-medication-block page-section">
          <div className="storyboard-medication-grid z-10 grid grid-cols-2 gap-[0.28571429in] print:gap-[0.2in]">
            <StepCard
              step={1}
              title="How does the medication work?"
              label={medication?.content?.howItWorks?.label}
              items={medication?.content?.howItWorks?.listItems}
              icon={medication?.content?.howItWorks?.icon}
            />
            <StepCard
              step={2}
              title="How do I take the medication?"
              label={medication?.content?.howToTake?.label}
              items={medication?.content?.howToTake?.listItems}
              icon={medication?.content?.howToTake?.icon}
            />
            <StepCard
              step={3}
              title="How do I know the medication is working?"
              label={medication?.content?.howToKnowItsWorking?.label}
              items={medication?.content?.howToKnowItsWorking?.listItems}
              icon={medication?.content?.howToKnowItsWorking?.icon}
            />
            <StepCard
              step={4}
              title="How do I manage side effects?"
              label={medication?.content?.howToManageSideEffects?.label}
              items={medication?.content?.howToManageSideEffects?.listItems}
              icon={medication?.content?.howToManageSideEffects?.icon}
            />
          </div>
          <div className="storyboard-medication-frame absolute z-0 -inset-[0.14285714in] -bottom-[0.15714286in]">
            <svg
              width="100%"
              height="100%"
              viewBox="0 0 555 311"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              preserveAspectRatio="none"
            >
              <path
                d="M1 1.5H278H541.5C548.127 1.5 553.5 6.87258 553.5 13.5V144C553.5 150.627 548.127 156 541.5 156H13C6.37258 156 1 161.373 1 168V297.5C1 304.127 6.37258 309.5 13 309.5H553.5"
                stroke="#017E9D"
                stroke-width="2"
              />
            </svg>
          </div>
        </div>
      </div>
    </div>
  );
};

const StepCard = ({
  step = 0,
  title = "",
  label = "",
  items = [],
  icon = <></>,
}) => (
  <div className="storyboard-step-card page-section relative bg-teal-25 rounded-[0.14285714in] p-[0.17142857in] min-h-[1.9142857in]">
    <div className="flex flex-row gap-[0.085714286in] flex-nowrap h-full">
      <div className="w-[0.38571429in] h-full flex flex-col justify-between">
        <p className="text-[0.45714286in] font-bold text-REELTeal">{step}</p>
        <div>{icon}</div>
      </div>
      <div className="flex-grow w-full">
        <p className="mb-[0.17142857in] font-bold text-[0.17142857in] text-teal-300">
          {title}
        </p>
        <ul className="mt-[0.17142857in] font-medium space-y-[0.11428571in]">
          {[label, ...items].map((item, i) =>
            item ? (
              <li
                key={item || i}
                className={`${
                  i > 0 ? "pl-[0.15714286in]" : ""
                } text-gray-600 relative text-[0.15714286in]`}
              >
                {i > 0 ? (
                  <span className="absolute left-0 text-REELTeal flex items-center justify-center min-h-[0.17142857in]">
                    <svg
                      width="0.085714286in"
                      height="0.085714286in"
                      viewBox="0 0 6 6"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle cx="2.5" cy="3" r="2" stroke="#017E9D" />
                    </svg>
                  </span>
                ) : null}
                {item}
              </li>
            ) : null
          )}
        </ul>
      </div>
    </div>
    <div
      className={`absolute z-10 ${
        step === 1 ? "-left-[0.24285714in] -top-[0.221428571in]" : ""
      } ${step === 4 ? "-right-[0.24285714in] -bottom-[0.221428571in]" : ""} ${
        step !== 1 && step !== 4 ? "hidden" : ""
      }`}
    >
      <svg
        width="0.2in"
        height="0.2in"
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect x="1" y="1" width="12" height="12" rx="6" fill="white" />
        <rect
          x="1"
          y="1"
          width="12"
          height="12"
          rx="6"
          stroke="#017E9D"
          strokeWidth="2"
        />
        <circle cx="7" cy="7" r="3.5" fill="#017E9D" />
      </svg>
    </div>
  </div>
);
